import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  
  Form,
  Col,
} from "react-bootstrap";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend, 
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import { useNavigate } from "react-router";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/BugService";
const BugReportPage = () => {
  const [bugs, setBugs] = useState([]);
  const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#d45087", "#546de5"];
const [tasks, setTask] = useState([]);
  const navigate = useNavigate();
  const [filteredBugs, setFilteredBugs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [taskFilter, setTaskFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [dueDateFilter, setDueDateFilter] = useState("");
  useEffect(() => {
    const fetchBugs = async () => {
      try {
        const response = await AxiosInstance.get(API_ENDPOINTS.GET_BUG_LIST);
        setBugs(response.data);
        setFilteredBugs(response.data);
      } catch (error) {
        console.error("Error fetching bugs:", error);
      }
    };
    const fetchProjects = async () => {
      try {
        const projectResponse = await AxiosInstance.get(API_ENDPOINTS.GET_TASK_NAME);
        setTask(projectResponse.data || []);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProjects();
    fetchBugs();
  }, []);

useEffect(() => {
    let updatedBugs = [...bugs];

    if (searchQuery) {
      updatedBugs = updatedBugs.filter((bug) =>
        bug.bugName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (priorityFilter) {
      updatedBugs = updatedBugs.filter((bug) => bug.priority === priorityFilter);
    }

    if (taskFilter) {
      updatedBugs = updatedBugs.filter((bug) => bug.projectTaskId === taskFilter);
    }

    if (dueDateFilter) {
      updatedBugs = updatedBugs.filter(
        (bug) => new Date(bug.dueDate).toISOString().split("T")[0] === dueDateFilter
      );
    }

    setFilteredBugs(updatedBugs);
  }, [searchQuery, priorityFilter, taskFilter, dueDateFilter, bugs]);

  const handleClick = (bugId) => {
    navigate("/bugdetails", { state: { bugId } });
  };

  // Data Transformation
  const statusData = bugs.reduce((acc, bug) => {
    const status = bug.status || "Unknown";
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const statusChartData = Object.keys(statusData).map((key) => ({
    name: key,
    value: statusData[key],
  }));

  const expiredBugs = filteredBugs.filter((bug) => new Date(bug.dueDate) < new Date());

  const priorityData = bugs.reduce((acc, bug) => {
    const priority = bug.priority || "Unknown";
    acc[priority] = (acc[priority] || 0) + 1;
    return acc;
  }, {});

  const priorityChartData = Object.keys(priorityData).map((key) => ({
    name: key,
    value: priorityData[key],
  }));

  // Styling
  const paperStyle = { padding: "16px", textAlign: "center" };
  const handleBugClick = (bugId) => {
    navigate("/bugdetails", { state: { bugId } });
  };
  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Total {bugs.length} Bugs
      </Typography>

      <Grid container spacing={3}>
        {/* Status Chart */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} style={paperStyle}>
            <Typography variant="h6">Status Report</Typography>
            <PieChart width={400} height={300}>
              <Pie
                data={statusChartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={(entry) => `${entry.name}: ${entry.value}`}
              >
                {statusChartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </Paper>
        </Grid>

        {/* Priority Chart */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} style={paperStyle}>
            <Typography variant="h6">Priority-Wise Distribution</Typography>
            <BarChart width={400} height={300} data={priorityChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#82ca9d">
                {priorityChartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </Paper>
        </Grid>

        {/* Expired Bugs Table */}
        <Grid item xs={12}>
          <Paper elevation={3} style={paperStyle}>
            <Typography variant="h6">Expired Tasks</Typography>
            <div className="d-flex">
          <Col md={3}>
            <Form.Control
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Bug Name"
            />
          </Col>

          <Col md={3} className="ms-4">
  <Form.Select
    value={taskFilter}
    onChange={(e) => setTaskFilter(e.target.value)}
  >
    <option value="">All Tasks</option>
    {tasks.map((task) => (
      <option key={task.projectTaskId}>
        {task.taskName}
      </option>
    ))}
  </Form.Select>
</Col>


          <Col md={2} className="ms-4">
            <Form.Select
              value={priorityFilter}
              onChange={(e) => setPriorityFilter(e.target.value)}
            >
              <option value="">All Priorities</option>
              <option>High</option>
              <option>Medium</option>
              <option>Low</option>
              <option>Critical</option>
            </Form.Select>
          </Col>

          <Col md={2} className="ms-4">
            <Form.Control
              type="date"
              value={dueDateFilter}
              onChange={(e) => setDueDateFilter(e.target.value)}
            />
          </Col>
        </div>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Bug ID</TableCell>
                    <TableCell>Bug Name</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Assigned To</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Due Date</TableCell>
                    <TableCell>Priority</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expiredBugs.length > 0 ? (
                    expiredBugs.map((bug) => (
                      <TableRow key={bug.bugId}  onClick={() =>handleBugClick(bug.bugId)}>
                        <TableCell>{bug.bugId}</TableCell>
                        <TableCell>{bug.bugName}</TableCell>
                        <TableCell>{bug.bugDescription}</TableCell>
                        <TableCell>{bug.assignedTo}</TableCell>
                        <TableCell>{bug.status}</TableCell>
                        <TableCell>
                          {new Date(bug.dueDate).toLocaleDateString()}
                        </TableCell>
                        <TableCell>{bug.priority}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No expired tasks.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BugReportPage;
